// extracted by mini-css-extract-plugin
export default {"text":"SalesforceAgreements__text-PcHay","right":"SalesforceAgreements__right-qgEBn"};